window.SpeechSDK = require('./distrib/microsoft.cognitiveservices.speech.sdk.js');



//////////////////
// WEBPACK FOOTER
// ./bundleApp.js
// module id = 21
// module chunks = 0